<div class="network-status-banner" [@slideInOut]="showBanner ? 'visible' : 'hidden'" *ngIf="isOffline">
  <div class="banner-content">
    <!-- Ícone WiFi animado -->
    <svg class="wifi-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        class="wifi-wave wifi-wave-3"
        d="M1.5 8.5C5.5 4.5 11.5 4.5 12 4.5C12.5 4.5 18.5 4.5 22.5 8.5"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        class="wifi-wave wifi-wave-2"
        d="M5 12C7.5 9.5 10.5 9 12 9C13.5 9 16.5 9.5 19 12"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        class="wifi-wave wifi-wave-1"
        d="M8.5 15.5C9.83333 14.1667 11 14 12 14C13 14 14.1667 14.1667 15.5 15.5"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
      />
      <circle cx="12" cy="19" r="1.5" fill="currentColor" />
      <!-- Linha diagonal de "sem sinal" -->
      <line
        class="no-signal-line"
        x1="4"
        y1="20"
        x2="20"
        y2="4"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
      />
    </svg>

    <span class="message">{{ 'ERRORS.NO_INTERNET' | translate }}</span>

    <button class="dismiss-btn" (click)="dismiss()" aria-label="Fechar">
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
      </svg>
    </button>
  </div>
</div>
